import React from "react";
import { MARQUEE_ITEMS } from "../mock";

const Marquee = () => {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div className="border-y border-[#B88A3B]/30 bg-[#F6F1E8] py-6 overflow-hidden">
      <div className="flex w-max animate-marquee">
        {items.map((item, i) => (
          <span key={i} className="flex items-center gap-24 mr-24">
            <span className="font-serif-lux italic text-2xl text-[#B88A3B]/90 whitespace-nowrap">
              {item}
            </span>
            <span className="w-1.5 h-1.5 rotate-45 bg-[#B88A3B]/50 shrink-0" />
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
